module.exports = __webpack_public_path__ + "img/battery_2blue.6d0b2e0d.png";